import { BuilderState } from '@/types/builder';
import { LinkButton } from '../LinkButton/LinkButton';
import Card from '@tempcover/bolt-ui/card';
import { ExpertProfile } from '../ExpertQuote/ExpertQuote';
import { host } from '@/config';

export const ALL_EXPERTS_COMPONENT_NAME = 'All Experts';

interface AllExpertsProps {
  heading: string;
  body: string;
  builderState: BuilderState;
}

export const AllExperts = ({
  heading,
  body,
  builderState: {
    state: { experts }, // Provided by Builder at page-level
  },
}: AllExpertsProps) => {
  const sortedExperts = [...experts].sort((a, b) => a.name.localeCompare(b.name));
  return (
    <>
      <h2>{heading}</h2>
      <div dangerouslySetInnerHTML={{ __html: body }} />
      <ul className="m-0 p-0">
        {sortedExperts.map(({ name, url, avatar, story, jobtitle }) => (
          <li key={name} className="flex">
            <Card className="flex md:flex-row">
              <div className="align-center flex flex-1/5">
                <ExpertProfile profileImage={avatar} name={name} jobTitle={jobtitle ?? 'N/A'} />
              </div>
              <div className="flex-4/5">
                <div dangerouslySetInnerHTML={{ __html: story }} />
                <div>
                  <LinkButton variant="tertiary" label={`View profile`} link={`${host}${url}`} size={'smallPadded'} />
                </div>
              </div>
            </Card>
          </li>
        ))}
      </ul>
    </>
  );
};
